// eslint-disable-next-line import/prefer-default-export
export const GET_COUPONS_SUCCESS = 'GET_COUPONS_SUCCESS';
